<template>
  <v-card
    elevation="0"
    color="rgba(0,0,0,0)"
  >
    <p class="overline ml-2 mt-4 mb-1">Publicidade</p>
    <v-responsive class="round-corner">
      <v-carousel
        cycle
        height="100%"
        hide-delimiters
        continuous
        interval="8000"
        :show-arrows="false"
      >
        <v-carousel-item
          v-for="(item, i) in items"
          :aspect-ratio="10/1.5"
          :key="i"
          :src="item.src"
          target="_blank"
          :href="item.href"
        >
        </v-carousel-item>
      </v-carousel>
    </v-responsive>
  </v-card>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
  name: 'SliderMain',
  data(){
    return{
      items: [
        // {
        //   src: require('@/assets/slider-1.png'),
        //   href: 'https://www.agencia352.com/medical',
        // },
        // {
        //   src: require('@/assets/slider-2.png'),
        //   href: 'https://www.google.com',
        // },
        // {
        //   src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
        //   href: 'https://www.google.com',
        // },
      ],
    }
  },
  methods: {
    getAd(){
      db.collection('banner-ad').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let i = doc.data()
          let newSrc
          newSrc = 'https://centrofluminense.com.br/webmeeting-img/img/ad/' + i.src
          i.src = newSrc
          this.items.push(i)
        })
      })
    },
  },
  mounted(){
    this.getAd()
  }
}
</script>

<style lang="scss">
.v-caroussel-item{
  overflow: hidden;
}
</style>